export function fillSubfieldsWithDefaults (fieldsConfig, initialValue) {
  return Object.entries(fieldsConfig).reduce((acc, curr) => {
    const [ key, value ] = curr
    if (value.config?.default) {
      acc[key] = value.config.default.value
    }
    return acc
  }, initialValue)
}
